import filter from 'lodash/filter';
import some from 'lodash/some';

import { registerDecorator, ValidationArguments, ValidationOptions } from 'class-validator';
import { BusinessOfficeHours, ScheduleException } from '../BusinessHours';

export const IsBusinessHoursExceptionHasNoDuplicates =
  (validationOptions?: ValidationOptions) => (object: Object, propertyName: string) => {
    registerDecorator({
      name: 'isBusinessHoursExceptionUnique',
      target: object.constructor,
      propertyName: propertyName,
      constraints: [],
      options: validationOptions,
      validator: {
        validate(_, args: ValidationArguments) {
          const exceptions = (args.object as BusinessOfficeHours).exceptions;
          if (!exceptions || exceptions.length === 1) {
            return true;
          }

          return !exceptionsListIncludeDuplicates(exceptions);
        },
        defaultMessage() {
          return 'This exception already exists';
        },
      },
    });
  };

const exceptionsListIncludeDuplicates = (exceptions: ScheduleException[]) => {
  return some(exceptions, currentException => exceptionIsDuplicated(currentException, exceptions));
};

export const exceptionIsDuplicated = (currentException: ScheduleException, exceptions: ScheduleException[]) => {
  const similarExceptions = filter(exceptions, exception => {
    return (
      exception.name &&
      currentException.name &&
      exception.start &&
      currentException.start &&
      exception.stop &&
      currentException.stop &&
      (exception.name === currentException.name ||
        (exception.start === currentException.start && exception.stop === currentException.stop))
    );
  });

  return similarExceptions.length > 1;
};
